import React, {Component} from 'react';
import Script from 'react-load-script';
import {Loader} from "../Common/Loader";

class Donate extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showLoader: true
        }
    }

    componentDidMount() {
        const s = document.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = "https://www.iatspayments.com/AURA/AURA.aspx?PID=PA89920A3F1E33EAEA";
        this.instance.appendChild(s);

        const pointer = this;

        setTimeout(function () {
            pointer.setState({showLoader: false});
        }, 2000);
    }

    render() {
        return (
            <div ref={el => (this.instance = el)}>
                <p style={{textAlign: 'center'}}>
                    Your donation will be processed by The Ocean Foundation in Washington DC, our 501 (c) (3)<br/>fiscal sponsor. You will receive an official receipt for your tax records from The Ocean Foundation.
                </p>
                {
                    this.state.showLoader ?
                        <Loader/>
                    : null
                }
            </div>
        );

    }
}

export default Donate;



// WEBPACK FOOTER //
// ./components/Donate/Donate.js